import type React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { isPresent } from "@apl-digital/utils";

import { useAppSelector } from "@/store";
import { selectProductById, selectProducts } from "@/store/products/selectors";

import {
  type CurrentProductState,
  ProductPageContext,
} from "./useProductPageContext";

type ProductPageContextProviderProps = {
  children?: React.ReactNode;
};

export const ProductPageContextProvider: React.FC<
  ProductPageContextProviderProps
> = ({ children }) => {
  const { productID } = useParams();

  const [currentProduct, setCurrentProduct] = useState<CurrentProductState>({
    status: "idle",
    state: { productId: productID },
  });

  const products = useAppSelector(selectProducts);
  const foundProduct = useAppSelector((state) =>
    isPresent(productID)
      ? selectProductById(state, Number(productID))
      : undefined,
  );

  useEffect(() => {
    if (isPresent(productID) && isPresent(products) && products.length > 0) {
      if (isPresent(foundProduct)) {
        setCurrentProduct({ status: "loaded", state: foundProduct });
      } else {
        setCurrentProduct({
          status: "notFound",
          state: { productId: productID },
        });
      }
    }
  }, [productID, products, foundProduct]);

  return (
    <ProductPageContext.Provider
      value={{
        currentProduct,
      }}
    >
      {children}
    </ProductPageContext.Provider>
  );
};
